import { render, staticRenderFns } from "./ToolbarGuide.vue?vue&type=template&id=0b572da8"
import script from "./ToolbarGuide.vue?vue&type=script&lang=js"
export * from "./ToolbarGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports